export const SODIUM_HARD_CONSTRAINT_OPT_OUT_LS_KEY =
  'sodium-hard-constraint-opt-out';
